import moment from "moment";

export const arrayToCsv = (array) => {
  return array.sort().reduce((one, str, index) => {
    return `${one}${index > 0 ? ', ' : ''}${str}`;
  }, '').toUpperCase();
};


export const formatCourse = (course, includeExamClasses = false, separator = " / ", courseExamClassSeparator = separator, examClassSeparator = ",") => {
  const { courseUnit, courseYear, courseNumber, examClasses } = course;
  const examClassNames =(examClasses || []).map(ec => ec.name || ec).join(examClassSeparator);
  if (courseNumber && courseUnit && courseYear) {
    const courseName = `${courseNumber}${separator}${courseYear}${separator}${courseUnit}`;
    const classNames = (examClassNames.length > 0 && includeExamClasses) ? courseExamClassSeparator + examClassNames : "";
    return courseName + classNames;
  }
  return null;
};

export const formatCourseCompact = (course, includeExamClasses = false, courseExamClassSeparator = "/") => formatCourse(course, includeExamClasses, "/", courseExamClassSeparator);

export const formatCourseWithExamClassesCompact = (course) => formatCourseCompact(course, true, " ");

export const formatApproverInfo = (approvalTimestamp, approver) => {
  return `(${moment(approvalTimestamp).format(
    "DD.MM.YYYY"
  )}, ${approver})`;
}

export const formatShortLessonDescription = (description) => description ? description.split(" ", 2)[0] : description;

/**
 * Can be used to add `str` between jsx elements generated by mapping over an array
 * 
 * eg. 
 * ```
 * ["foo", "bar"].map((item, idx, arr) => <Span id=...>{item + jsxJoinWith(idx, arr, ",")}</Span>)
 * ```
 * @param {*} idx current index
 * @param {*} arr array
 * @param {*} str delimeter
 * @returns delimeter for all but last element
 */
export const jsxJoinWith = (idx, arr, str) => (idx === arr.length - 1) ? "" : str;


export const formatLoggedUserFullName = (user) => (user ? [user.sn, user.givenname] : []).filter(Boolean).join(" ");



// WEBPACK FOOTER //
// ./src/util/FormatUtil.js